import { Link } from "react-router-dom";
import { useSettings } from "../lib/SettingsContext";
import { uploadUrl } from "../lib/api";

export const Logo = ({ dark = false, suffix = null, testid = "logo" }) => {
  const { settings } = useSettings();
  const custom = settings.logo_url ? uploadUrl(settings.logo_url) : null;

  if (custom) {
    return (
      <Link to="/" data-testid={testid} className="inline-flex items-center shrink-0">
        <img src={custom} alt="V32 Group" className="h-8 w-auto object-contain" />
      </Link>
    );
  }

  return (
    <Link
      to="/"
      data-testid={testid}
      className="inline-flex items-baseline gap-2 shrink-0 group"
      aria-label="V32 Group — Home"
    >
      <span
        className={`font-display font-semibold text-2xl tracking-tight leading-none transition-colors duration-300 ${
          dark ? "text-avorio" : "text-ink"
        }`}
      >
        V32
      </span>
      <span
        className={`font-mono text-[10px] uppercase tracking-[0.35em] transition-colors duration-300 ${
          dark ? "text-pietra" : "text-pietra"
        } group-hover:text-bronzo`}
      >
        {suffix || "Group"}
      </span>
    </Link>
  );
};
